/**
 * The three brand collections that are linked by hand from the footer and the
 * homepage, rather than rendered from an API response.
 *
 * WHY THIS FILE EXISTS: those links used to be written as
 * `{ name: 'catalog-category', params: { category: '  650' } }`, which produces
 * /catalog/%20%20650 — the raw EBMS tree id, leading spaces and all. That URL
 * is not broken (pages/catalog/_category.vue 301s it to the clean slug), but it
 * costs a redirect and puts a non-canonical URL in the page's internal links.
 * The ids were duplicated across six places, so each new collection meant the
 * same mistake again.
 *
 * Anything rendered FROM catalogue data must not use this list — it should call
 * getCategoryLink(category) from mixins/global.js, which already prefers
 * `category.slug` and only falls back to a tree id when the slug sync has not
 * run yet. That path picks up new EBMS items automatically. This list is only
 * for hand-curated links, where a human is choosing which collections to
 * feature anyway.
 *
 * Slugs come from `admin:inventre:slug` (EBMS INVENTRE.TREE_DESCR). Renaming a
 * collection in EBMS changes its slug, so if one of these ever 404s, check the
 * new slug with GET {API}/catalog-type?treeId=<id> and update it here.
 */
export const BRAND_COLLECTIONS = {
  DUNDALK: { treeId: "  650", slug: "dundalk-collection", name: "Dundalk Collection" },
  PURE_CUBE: { treeId: "  651", slug: "pure-cube-collection", name: "Pure Cube Collection" },
  CANADIAN_TIMBER: { treeId: "  652", slug: "canadian-timber-collection", name: "Canadian Timber Collection" },
};

/**
 * Clean path for a hand-linked collection. Falls back to the tree-id route only
 * if a slug is somehow missing, so a typo degrades to a redirect rather than a
 * dead link.
 */
export function collectionPath(collection) {
  if (!collection) return "/catalog";
  return collection.slug ? `/${collection.slug}` : `/catalog/${collection.treeId}`;
}
